import React from 'react'
import TableCellMobile from './TableCellMobile'
import TableCellDesktop from './TableCellDesktop'

const TableCellPrix = ({
  item,
  label,
  device
}) => {
  const value = item.reel + '€'
  return (device.mobile)
    ? <TableCellMobile
        label={label}
        value={value}
      />
    : <TableCellDesktop
        max={75}
        value={value}
      />
}

export default TableCellPrix
